// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__q0vQ-","boxModel":"styles_boxModel__FQM2-","cross":"styles_cross__ynrm4"};